import { render, staticRenderFns } from "./TaskMilestoneAttachedActivity.vue?vue&type=template&id=51f004c1"
import script from "./TaskMilestoneAttachedActivity.vue?vue&type=script&lang=js"
export * from "./TaskMilestoneAttachedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports